<template>
  <div class="refund-reservation">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <div class="col-sm-12">
            <div class="box box-primary">
              <div class="box-header">
                <h1 class="box-title">Reservation Charges</h1>
              </div>
              <div class="billing-table">
                <div class="row billing-headings">
                  <div class="col-xs-6">
                    Description
                  </div>
                  <div class="col-xs-2">
                    Cost
                  </div>
                  <div class="col-xs-4">
                  </div>
                </div>
                <div class="billing-header"></div>
                <div v-for="charge in charges" class="row billing-item">
                  <div class="col-xs-6">
                    {{ charge.description }} <span class="label label-warning" v-if="charge.pending">Pending</span>
                  </div>
                  <div class="col-xs-2">
                    {{ charge.cost | to_dollar_amount }}
                  </div>
                  <div class="col-xs-4">
                    <button class="btn btn-info btn-xs" @click="refundCharge(charge)"><span class="fa fa-exchange-alt"></span> Refund</button>
                  </div>
                </div>
                <div class="row billing-item">
                  <div class="col-xs-6">
                    Total
                  </div>
                  <div class="col-xs-2">
                    {{ totalCharges | to_dollar_amount }}
                  </div>
                  <div class="col-xs-4">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="box box-primary">
              <div class="box-header">
                <h1 class="box-title">Refunds</h1>
              </div>
              <div class="billing-table">
                <div class="row billing-headings">
                  <div class="col-xs-6">
                    Description
                  </div>
                  <div class="col-xs-2">
                    Cost
                  </div>
                  <div class="col-xs-4">
                  </div>
                </div>
                <div class="billing-header"></div>
                <div v-for="charge in refundCharges" class="row billing-item">
                  <div class="col-xs-6">
                    {{ charge.description }} <span class="label label-warning" v-if="charge.pending">Pending</span>
                  </div>
                  <div class="col-xs-2">
                    {{ charge.cost | to_dollar_amount }}
                  </div>
                  <div class="col-xs-4">
                    <button class="btn btn-warning btn-xs" @click="removeRefund(charge)">Remove</button>
                  </div>
                </div>
                <div v-for="charge in refundedCharges" class="row billing-item">
                  <div class="col-xs-6">
                    {{ charge.description }}
                  </div>
                  <div class="col-xs-2">
                    {{ charge.cost | to_dollar_amount }}
                  </div>
                  <div class="col-xs-4">
                    <button class="btn btn-default btn-xs" disabled>Remove</button>
                  </div>
                </div>
                <div class="row billing-item">
                  <div class="col-xs-6">
                    Total
                  </div>
                  <div class="col-xs-2">
                    {{ totalRefunded | to_dollar_amount }}
                  </div>
                  <div class="col-xs-4">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="refundCharges.length > 0" class="row">
      <div class="col-sm-12">
        <div class="box box-primary">
          <div class="box-header">
            <h1 class="box-title">Process Refunds</h1>
          </div>
          <div class="box-body">
            <p>The amount of {{ amountToRefund | to_dollar_amount }} will be refunded. Please enter your reason for refunding this charge below:</p>
            <textarea v-model="refundReason"></textarea>
            <div v-if="noReason" class="alert alert-danger">
              Please enter a reason for refunding this charge before processing it.
            </div>
            <div class="row">
              <div class="col-sm-2 offset-10">
                <button class="btn btn-default" @click="processRefunds()">Accept</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
      <div class="col-sm-7">
        <div class="row">
          <div class="col-md-6">
            <div class="box-header">
              <h1 class="box-title">Reservation Details</h1>
            </div>
            <div class="list-group-item">
              <reservation-display :reservation="reservation"></reservation-display>
            </div>
          </div>
          <div class="col-md-6">
            <div class="box-header">
              <h1 class="box-title">Notes</h1>
            </div>
            <div class="list-group-item" v-for="note in notes">
              <account-note-display :data="note"></account-note-display>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- charge complete modal -->
    <modal ref="completeModal" v-if="completing">
      <template slot="header">
        <h4 class="modal-title">Success</h4>
      </template>
      <template slot="body">
        <div v-html="message"></div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from '../Modal'
import Util from '../../../server/util'
import AccountNoteDisplay from '../displays/AccountNoteDisplay'
import ReservationDisplay from '../displays/ReservationDisplay'
export default {
  name: 'ReservationRefund',
  components: {
    Modal,
    AccountNoteDisplay,
    ReservationDisplay
  },
  data () {
    return {
      completing: false,
      reservation: {},
      notes: [],
      refundCharges: [],
      charges: [],
      refundedCharges: [],
      totalRefunded: 0,
      totalCharges: 0,
      amountToRefund: 0,
      refundReason: '',
      noReason: false,
      message: ''
    }
  },
  route: {
    data () {
    }
  },
  events: {
  },
  mounted () {
    this.getCharges()
  },
  methods: {
    processRefunds () {
      this.noReason = false
      if (!this.refundReason) {
        this.noReason = true
      } else {
        let { meta } = this.$route.matched.find(m => m.meta.authType)
        this.$http.post(`${meta.authType}/object/refundCharges`, {
          charges: this.refundCharges,
          refundReason: this.refundReason,
          accountUuid: this.reservation.AccountUuid,
          reservationUuid: this.reservation.uuid,
          amountRefunded: this.amountToRefund
        })
        .then(({ data }, status, request) => {
          if (data.object.error) {
            this.message = `
            <div class="callout callout-danger">
            <p>${data.object.error}</p>
            </div>`
          } else {
            this.message = data.object.success
          }
          this.completing = true
          this.$nextTick(function () {
            $(this.$refs.completeModal).modal()
            $(this.$refs.completeModal).on('hidden.bs.modal', (e) => {
              this.completing = false
              this.getCharges()
            })
          })
        })
      }
    },
    getCharges () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/getRefundCharges`, {
        params: this.$route.params
      }).then(({ data }, status, request) => {
        this.refundedCharges = []
        this.charges = []
        this.reservation = data.object
        this.notes = data.object.AccountNotes
        this.reservation.ReservationCharges.forEach(charge => {
          if (charge.refunded) {
            this.refundedCharges.push(charge)
            this.totalRefunded = Util.round(this.totalRefunded + parseFloat(charge.cost))
          } else {
            this.charges.push(charge)
            this.totalCharges = Util.round(this.totalCharges + parseFloat(charge.cost))
          }
        })
        this.reservation.CreditCharges.forEach(charge => {
          if (charge.amount) {
            charge.cost = charge.amount
          }
          if (charge.refunded) {
            this.refundedCharges.push(charge)
            this.totalRefunded = Util.round(this.totalRefunded + parseFloat(charge.cost))
          } else {
            this.charges.push(charge)
            this.totalCharges = Util.round(this.totalCharges + parseFloat(charge.cost))
          }
        })
      })
    },
    refundCharge (charge) {
      this.noReason = false
      this.refundCharges.push(charge)
      this.charges.$remove(charge)
      this.totalRefunded = Util.round(this.totalRefunded + parseFloat(charge.cost))
      this.amountToRefund = Util.round(this.amountToRefund + parseFloat(charge.cost))
      this.totalCharges = Util.round(this.totalCharges - parseFloat(charge.cost))
    },
    removeRefund (charge) {
      this.noReason = false
      this.charges.push(charge)
      this.refundCharges.$remove(charge)
      this.totalRefunded = Util.round(this.totalRefunded - parseFloat(charge.cost))
      this.amountToRefund = Util.round(this.amountToRefund - parseFloat(charge.cost))
      this.totalCharges = Util.round(this.totalCharges + parseFloat(charge.cost))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/ReservationRefund.vue